'use strict';

var template = require('../templates/geo.ejs');
var GeoView = require('standard-vote/app/scripts/views/geo');

module.exports = GeoView.extend({

    render: function () {
        document.body.classList.add('geo');
        this.$el.html(template(this.model));
        return this;
    }

});



// WEBPACK FOOTER //
// ./app/scripts/views/geo.js